import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import accountReducer from './features/Slices/accountSlice';
import budgetReducer from './features/Slices/budgetSlice';
import bucketNodeReducer from './features/Slices/bucketNodeSlice';
import checkRequestReducer from './features/Slices/checkRequestSlice';
import isMobileReducer from './features/Slices/isMobileSlice';
import localDataReducer from './features/Slices/localDataSlice';
import modalReducer from './features/Slices/modalSlice';
import receiptEmailReducer from './features/Slices/receiptEmailSlice';
import timeframeReducer from './features/Slices/timeframeSlice';
import transactionReducer from './features/Slices/transactionSlice';
import userDataReducer from './features/Slices/userDataSlice';
import userReducer from './features/Slices/userSlice';
import modalSpaceReducer from './features/Slices/modalSpaceSlice';
import savedReportsReducer from './features/Slices/savedReportsSlice';

export default configureStore({
    reducer: {
        accounts: accountReducer,
        budgets: budgetReducer,
		bucketNodes: bucketNodeReducer,
		checkRequests: checkRequestReducer,
		isMobile: isMobileReducer,
		localData: localDataReducer,
		modal: modalReducer,
        timeframes: timeframeReducer,
        receiptEmails: receiptEmailReducer,
        transactions: transactionReducer,
		userData: userDataReducer,
		users: userReducer,
		modalSpace: modalSpaceReducer,
		savedReports: savedReportsReducer,
	},
	middleware: getDefaultMiddleware({
		serializableCheck: false
	})
});